const errorMapping = {
    '3.01': {
        title: 'We couldn’t process your payment',
        description: 'Your bank blocked this payment because you may have reached a spending limit, or there’s a security step your bank requires',
        helpDescription: 'Call your bank, ask them to check your card limits and remove the block. Then try again.'
    },
    '3.02': {
        title: "We Couldn't Process Your Payment",
        description: 'Your bank account balance is insufficient to complete the purchase.',
        helpDescription: 'Try using another card, or add money to this one and try again.'
    },
    '3.03': {
        title: 'You reached the spending limit on your card',
        description: 'Your bank declined this payment because you reached your card’s spending limit',
        helpDescription: 'Contact your bank’s support team, ask them to remove the limit, and try again.'
    },
    '3.04': {
        title: 'Your card has reached its limit',
        description: 'Your bank didn’t approve the payment because you reached a limit on spending, payments, or transactions',
        helpDescription: 'Call your bank’s support, ask them to adjust your limit, and try again.'
    },
    '3.05': {
        title: 'This payment was declined by your bank',
        description: 'Your bank stopped the payment, possibly because of a limit',
        helpDescription: 'Contact your bank, ask them to check and adjust your limits, and try the payment again.'
    },
    '3.06': {
        title: 'We couldn’t process your debit card',
        description: 'Unfortunately, we don’t support debit cards for this payment',
        helpDescription: 'Try using a credit card and make a payment again.'
    },
    '3.07': {
        title: 'This card didn’t go through',
        description: 'The card you used isn’t supported for this payment',
        helpDescription: 'Try again using a different card type.'
    },
    '3.08': {
        title: 'We couldn’t process your payment',
        description: 'Your bank blocked this payment due to card limits, security settings, or other reasons',
        helpDescription: 'Try the payment again or use a different card. If it still doesn’t work, contact your bank and ask them to check your account.'
    },
    '5.01': {
        title: 'Your bank needs extra security to approve this payment',
        description: 'This payment requires extra security (called 3D Secure). Some banks may stop the payment if this step isn’t done',
        helpDescription: 'Use a different card and try again.'
    },
    '3.10': {
        title: 'We couldn’t complete your purchase',
        description: 'Your bank blocked this payment because of unusual activity or a long time with no card use',
        helpDescription: 'Contact your bank and ask if they can approve the payment.'
    },
    '4.03': {
        title: 'We couldn’t use your card for this payment',
        description: 'This payment requires extra security (called 3D Secure). Some banks may stop the payment if this step isn’t done',
        helpDescription: 'Use a different card and try again.'
    },
    '2.06': {
        title: 'The security code on your card didn’t match',
        description: 'It looks like the security code on your card (the 3-digit number on the back) is incorrect',
        helpDescription: 'Double-check the CVV number and try again. If it still doesn’t work, contact your bank to check your card.'
    },
    '2.08': {
        title: 'We couldn’t process the payment with this card',
        description: 'It looks like the card number you entered isn’t correct. This can happen if the card is closed, expired, or updated',
        helpDescription: 'Check your card number and try again. If it still doesn’t work, try a different card or contact your bank for help.'
    },
    '2.09': {
        title: 'We couldn’t process your card’s expiration date',
        description: 'It looks like your card’s expiration date is wrong or the card has expired',
        helpDescription: 'Double-check the expiration date on your card and try again. If your card is expired, use a different card.'
    },
    '2.11': {
        title: 'Your bank couldn’t complete the security check',
        description: 'It looks like your bank didn’t finish the extra security step needed for this payment',
        helpDescription: 'Try the payment again. If it still doesn’t work, try using a different card.'
    },
    '2.12': {
        title: 'We couldn’t confirm your payment',
        description: 'It looks like you need to finish the extra security step (3D Secure) your bank asks for',
        helpDescription: 'Try the payment again and follow the security step. If it still doesn’t work, use another card or contact your bank for help.'
    },
    '5.03': {
        title: 'There was a problem processing your payment',
        description: 'Something went wrong while we were handling your payment',
        helpDescription: 'Try the payment again, or use a different card. If the issue continues, contact your bank for help.'
    },
    '5.08': {
        title: 'We couldn’t process your payment',
        description: 'Something went wrong while we were handling your payment',
        helpDescription: 'Try the payment again. If it still doesn’t work, try using a different card.'
    },
    '6.02': {
        title: 'There was a connection issue',
        description: 'We couldn’t complete your payment because of a problem with the connection',
        helpDescription: 'Try the payment again. If it still doesn’t work, try using a different card.'
    },
    '3.09': {
        title: 'Your bank asks for an extra security step to approve this payment',
        description: 'This payment requires extra security (called 3D Secure). Don’t worry — this is a normal security check from your bank',
        helpDescription: 'Please check your phone or email for a message from your bank and follow the steps.'
    },
    '2.15': {
        title: 'Your bank asks for an extra security step to approve this payment',
        description: 'This payment requires extra security (called 3D Secure). Don’t worry — this is a normal security check from your bank',
        helpDescription: 'Please check your phone or email for a message from your bank and follow the steps.'
    }
};

const DEFAULT_ERROR = {
    title: 'We couldn’t process your payment',
    description: 'Your bank didn’t finish the payment this time',
    helpDescription: 'Try again a few times. If it still doesn’t work, call your bank for help.'
};

const paymentErrorMapper = {
    toDomain(errorCode) {
        return errorMapping[errorCode] || DEFAULT_ERROR;
    }
};

export {
    paymentErrorMapper
};
